module.exports = __webpack_public_path__ + "static/media/twitter.435fc4bc.svg";